import {MailOutlined, PhoneOutlined} from "@ant-design/icons";

import Logo from "../../assets/images/LogoEco.svg";
import Button from "../../components/button";
import * as S from "./styles";

function ComingSoon() {
  const handleEmailClick = () => {
    window.location.href = "mailto:info@ecosystemseurope.com";
  };

  const handlePhoneClick = () => {
    alert("Call us at +31(0)72 8200 270");
  };

  return (
    <S.Container>
      <S.Background />

      <S.Content>
        <S.Logo src={Logo} alt="Ecosystems Europe" />

        <S.Title>Coming soon</S.Title>
        <S.Subtitle>Our new website is under construction</S.Subtitle>

        <S.ButtonsWrapper>
          <Button onClick={handleEmailClick} text="Send Email" width="140px">
            <MailOutlined style={{fontSize: "30px"}} />
          </Button>

          <Button onClick={handlePhoneClick} text="+31(0)72 8200 270" width="198px">
            <PhoneOutlined style={{fontSize: "30px"}} />
          </Button>
        </S.ButtonsWrapper>
      </S.Content>
    </S.Container>
  );
}

export default ComingSoon;
